import ability from './ability'

export const canNavigate = to => {
  if (ability.can('ROLE_SUPER_USER', 'ACL')) return true

  return to.matched.every(route => {
    const { action } = route.meta
    const { resource } = route.meta
    if (!action) return true

    // Check if user has a master role that matches any segment in this matched hierarchy
    const userHasMaster = to.matched.some(r => {
      const parentAction = r.meta.action
      if (!parentAction) return false

      const masterRoles = [
        'ROLE_ADM_CONSULTAR',
        'ROLE_ADMIM_CONSULTAR',
        'ROLE_FINAN_CONSULTAR',
        'ROLE_ATEND_CONSULTAR',
      ]

      if (Array.isArray(parentAction)) {
        return parentAction.some(pa => masterRoles.includes(pa) && ability.can(pa, resource))
      }
      return masterRoles.includes(parentAction) && ability.can(parentAction, resource)
    })

    if (userHasMaster) return true

    if (Array.isArray(action)) {
      return action.some(a => ability.can(a, resource))
    }
    return ability.can(action, resource)
  })
}

export const _ = undefined
